// Resolving a shirt colour name against the product's colour list.
//
// The name reaches us from three places that do not agree on formatting - the
// parent frame's selectColor, the stored design row and /api/colors - and an
// exact-equality miss used to mean a silent reset to the first colour, which
// then got saved over the real one.

const norm = s => String(s).trim().toLowerCase().replace(/\s+/g, ' ');

export function findColor(list, name) {
	if (!list || !list.length || !name) return null;
	const exact = list.find(c => c.color === name);
	if (exact) return exact;
	const target = norm(name);
	return list.find(c => norm(c.color) === target) || null;
}
